import { render, staticRenderFns } from "./SortView.vue?vue&type=template&id=08dbe914&scoped=true&"
import script from "./SortView.vue?vue&type=script&lang=js&"
export * from "./SortView.vue?vue&type=script&lang=js&"
import style0 from "./SortView.vue?vue&type=style&index=0&id=08dbe914&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbe914",
  null
  
)

export default component.exports